<template>
  <detailTemplate :classCustom="'detail-docs'">
    <template #content>
      <div class="back-icon border-radius__50 clickable flex-row flex__center" @click="backListPage()">
        <i class="el-icon-back font-size__large"></i>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div class="font-size__large font-weight__bold margin-bottom-10" style="color: #007aff">
            TRẠNG THÁI TRÌNH TRẢ VĂN BẢN
          </div>
          <div>
            <el-table
              :data="hcCaseDocApprovers"
              border
              style="width: 100%">
              <el-table-column
                prop="approverFullname"
                label="LÃNH ĐẠO">
              </el-table-column>

              <el-table-column
                label="TRÌNH">
                <template slot-scope="scope">
                  <span v-if="scope.row.requestedDate">{{computeDate(scope.row.requestedDate)}}</span>
                  <el-button class="color__blue btn-none__border" size="mini" v-if="!scope.row.requestedDate"
                             @click="trinhVanBan(scope.row)">
                    <i class="fas fa-arrow-circle-right font-size__small"></i>&nbsp;Trình văn bản
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column
                label="TRẢ">
                <template slot-scope="scope">
                  <span v-if="scope.row.receivedDate">{{computeDate(scope.row.receivedDate)}}</span>
                  <el-button class="color__blue btn-none__border" size="mini" v-if="!scope.row.receivedDate"
                             @click="traVanBan(scope.row)">
                    <i class="fas fa-arrow-circle-right font-size__small"></i>&nbsp;Trả văn bản
                  </el-button>

                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>
      </VuePerfectScrollbar>

    </template>
  </detailTemplate>
</template>

<script type="text/javascript">
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import handleRequestErrorMixin from "../../handleRequestErrorMixin";
    import hanhchinhService from "../../../services/hanhchinhService";
    import moment from "moment";
    import {EventBus} from "../../../event-bus.js";

    export default {
        name: "LichTuan_Detail",
        mixins: [handleRequestErrorMixin],

        created() {
            // this.getListLeaders();
            this.getData();
            // this.getAction();
        },

        beforeDestroy() {
            if (this.hasChanged) {
                EventBus.$emit("reloadPage", {});
            }
        },

        data() {
            return {
                hcCaseDocApprovers: [],
                hcCaseMaster: {},
                hcCaseCalendar: {},
                hcCaseCalendarUsers: {},
                actions: [],
                approve: false,
                decline: false,
                update: false,
                cancel: false,
                selfCancel: false,
                listRooms: [],
                roomIdSelected: null,
                leaders: [],
                leadersSelected: [],
                hasChanged: false
            }
        },

        components: {
            VuePerfectScrollbar,
            detailTemplate: () => import("../../common/detail.vue"),
            Multiselect: () => import("vue-multiselect")
        },

        computed: {
            caseMasterId() {
                return this.$route.params.id;
            }
        },

        watch: {
            caseMasterId() {
                this.getData();
            }
        },

        methods: {
            backListPage() {
                this.$router.push({
                    name: "vbLuongVanBan",
                    query: this.$route.query,
                    params: this.$route.params
                });
            },

            // lay du lieu lich tuan chi tiet
            getData() {
                hanhchinhService.getDetailSteps(this.caseMasterId).then(
                    respone => {
                        this.hcCaseDocApprovers = respone.data.hcCaseDocApprovers;
                    }
                );
            },

            trinhVanBan(row) {
                let form = {
                    hcCaseDocApproverId: row.id
                };

                this.$confirm("Bạn có chắc muốn trình văn bản này?", {
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy bỏ",
                    type: "warning"
                }).then(() => {
                    hanhchinhService.trinhVanBan(form).then(res => {
                        this.getData();
                        this.hasChanged = true;
                    }).catch(error => this.commonHandleRequestError(error));
                });
            },

            traVanBan(row) {
                let form = {
                    hcCaseDocApproverId: row.id
                };

                this.$confirm("Bạn có chắc muốn trả văn bản này?", {
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy bỏ",
                    type: "warning"
                }).then(() => {
                    hanhchinhService.traVanBan(form).then(res => {
                        this.getData();
                        this.hasChanged = true;
                    }).catch(error => this.commonHandleRequestError(error));
                });
            },

            computeDate(date) {
                return moment(date).format("HH:mm DD/MM/YYYY");
            },

            notifyError(msg) {
                this.notify('Lỗi', msg, 'error', 2000);
            },

            notifySuccess(msg) {
                this.notify('Thông báo', msg, 'success', 2000);
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/views/adminstration/luongvanban/luongVb_DetailSteps.vue